import { AnyIfEmpty } from 'react-redux';
import {
    CLEAR_KEY_PICKUP_DROP_EVENTS_STATE,
    GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_FAILURE,
    GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_REQUEST,
    GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_SUCCESS,
} from '../constants/keyPickupDropEvents.constant';

// Initial state for vendor appointments
const initialState = {
    KeyPickupDropEvents: {
        loading: false,
        data: null,
        error: '',
    },
    accessCodeValidation: {
        loading: false,
        isValid: false,
        error: '',
    },
};

const keyPickupDropEventReducer = (state = initialState, action: AnyIfEmpty<object>) => {
    switch (action.type) {
        case GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_REQUEST:
            return {
                ...state,
                KeyPickupDropEvents: {
                    ...state.KeyPickupDropEvents,
                    loading: true,
                    data: null,
                    error: '',
                },
                accessCodeValidation: {
                    ...state.accessCodeValidation,
                    loading: true,
                    error: '',
                },
            };

        case GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_SUCCESS:
            return {
                ...state,
                KeyPickupDropEvents: {
                    ...state.KeyPickupDropEvents,
                    loading: false,
                    data: action.payload,
                    error: '',
                },
                accessCodeValidation: {
                    ...state.accessCodeValidation,
                    loading: false,
                    isValid: Array.isArray(action.payload) && action.payload.length > 0,
                    error: '',
                },
            };

        case GET_KEY_PICKUP_DROP_EVENTS_BY_ACCESS_CODE_FAILURE:
            return {
                ...state,
                KeyPickupDropEvents: {
                    ...state.KeyPickupDropEvents,
                    loading: false,
                    data: null,
                    error: action.payload,
                },
                accessCodeValidation: {
                    ...state.accessCodeValidation,
                    loading: false,
                    isValid: false,
                    error: action.payload,
                },
            };

        case CLEAR_KEY_PICKUP_DROP_EVENTS_STATE:
            return {
                ...state,
                KeyPickupDropEvents: {
                    loading: false,
                    data: null,
                    error: '',
                },
                accessCodeValidation: {
                    loading: false,
                    isValid: false,
                    error: '',
                },
            };

        default:
            return state;
    }
};

export default keyPickupDropEventReducer;
